<a
  mat-stroked-button
  disableRipple
  (click)="onClick()"
  [attr.aria-label]="localization.callForPrice"
  [matTooltip]="localization.callForPrice"
  #labelTooltip="matTooltip"
>
  <mat-icon>phone</mat-icon>
  <span label>{{ localization.callForPrice }}</span>
  <span label short>{{ localization.callForPriceShort }}</span>
</a>
